import React from 'react'

import PopUp from '../../../popUp'
import { cardPopin } from '../../../secondStep/helpers/drupalSettings'
import './cvvInfoPopin.scss'

const CvvInfoPopin = () => (
  <PopUp>
    <div className="cvv-popin__container">
      <div className="cvv-popin__title">
        {cardPopin.title}
      </div>
      <div className="cvv-popin__main">
        <div className="cvv-popin__main__left">
          <p className="cvv-popin__main__left__subtitle">
            {cardPopin.subtitle}
          </p>
          <p className="cvv-popin__main__left__description">
            {cardPopin.description}
          </p>
        </div>
        <div className="cvv-popin__main__right">
          <img
            src={cardPopin.image.src}
            alt={cardPopin.image.alt}
            title={cardPopin.image.title}
          />
        </div>
      </div>
    </div>
  </PopUp>
)

export default CvvInfoPopin
